import { TimesheetStatus } from '@sdk/timesheets/api/apiTypes';
import { ShiftTimesheets } from '@sdk/timesheets/types/ShiftTimesheets';
import { PersonasDict } from '@sdk/personaCollection/types/PersonasDict';
import { User } from '@sdk/users/types/User';

export const getLastEditedByName = (
  shift: ShiftTimesheets,
  personasDict: PersonasDict
): string | null => {
  const editedProjections = shift.timesheetProjections.filter(
    (timesheetProjection) =>
      (timesheetProjection.status === TimesheetStatus.pending ||
        timesheetProjection.status === TimesheetStatus.pendingConsent) &&
      timesheetProjection.lastEditedBy
  );

  if (editedProjections.length) {
    const lastEditedProjection = editedProjections[editedProjections.length - 1];
    const user = personasDict[lastEditedProjection.lastEditedBy.id] as User;
    return user?.fullname || '[unknown]';
  }

  return null;
};
